import { render, staticRenderFns } from "./video-detail.vue?vue&type=template&id=fd826ff8&scoped=true"
import script from "./video-detail.vue?vue&type=script&lang=js"
export * from "./video-detail.vue?vue&type=script&lang=js"
import style0 from "./video-detail.vue?vue&type=style&index=0&id=fd826ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd826ff8",
  null
  
)

export default component.exports